/**
 * Tarifas de despacho desde el backoffice (ADM-10).
 *
 * Las tres escrituras devuelven el panel completo y no la fila tocada: cambiar
 * una tarifa de region cambia tambien el resumen de sus excepciones, y
 * recomponerlo en el frontend seria repetir el calculo del servidor.
 */
import type {
  ActualizarConfiguracionDespachoDto,
  ActualizarTarifaRegionDto,
  DespachoAdmin,
  GuardarTarifaComunaDto,
} from '@elcarpintero/compartido';

import { pedir } from './cliente-api';

export function obtenerDespachoAdmin(senal?: AbortSignal): Promise<DespachoAdmin> {
  return pedir<DespachoAdmin>('/admin/despacho', { ...(senal ? { senal } : {}) });
}

export function guardarConfiguracionDespacho(
  datos: ActualizarConfiguracionDespachoDto,
): Promise<DespachoAdmin> {
  return pedir<DespachoAdmin>('/admin/despacho/configuracion', { metodo: 'PUT', cuerpo: datos });
}

export function guardarTarifaRegion(
  codigo: string,
  datos: ActualizarTarifaRegionDto,
): Promise<DespachoAdmin> {
  return pedir<DespachoAdmin>(`/admin/despacho/regiones/${codigo}`, {
    metodo: 'PUT',
    cuerpo: datos,
  });
}

export function guardarTarifaComuna(datos: GuardarTarifaComunaDto): Promise<void> {
  return pedir('/admin/despacho/comunas', { metodo: 'PUT', cuerpo: datos });
}

export function eliminarTarifaComuna(id: number): Promise<void> {
  return pedir(`/admin/despacho/comunas/${id}`, { metodo: 'DELETE' });
}
